import React from 'react'
import { observer } from 'mobx-react'
import useCart from 'services/cart/hooks/use-cart'

function CartWriter () {
  const cart = useCart()

  window.localStorage.setItem('cart', JSON.stringify(cart.toJSON()))

  return null
}

export default observer(CartWriter)
